import { api } from "infra/axios";
import { useQuery } from "react-query";
import { useIngressosStore } from "ui/pages/Admin/Ingresso/hooks/useIngressosStore";
import { EventoSetorOpcao } from "../types";

function useGetSetorOpcoes(onSuccess?: (data: EventoSetorOpcao[]) => void) {
  const eventoId = useIngressosStore((state) => state.eventoId);
  const calendarioId = useIngressosStore((state) => state.calendarioId);
  const endpoint = `v2/ingressos/evento/${eventoId}/setor-opcoes`;
  return useQuery(
    ["setor-opcoes", eventoId, calendarioId],
    async () => {
      const res = await api.get(endpoint, {
        params: { calendarioId },
      });
      return res.data as EventoSetorOpcao[];
    },
    {
      onSuccess,
      enabled: !!eventoId,
      refetchOnWindowFocus: false,
      staleTime: 0,
    }
  );
}
export default useGetSetorOpcoes;
